module.exports = __webpack_public_path__ + "static/media/team.aedbc5d5.svg";